import Layout from '@/layout'
const warrantyRouter = {
  path: '/warranty',
  component: Layout,
  name: 'warranty',
  meta: {
    title: '电子质保管理',
    icon: 'el-icon-document-copy',
    roles: ['root', 'sg_company', 'pdi_company', 'ec_company', 'jxs_shop', 'business']
  },
  children: [
    {
      path: 'create',
      name: 'WarrantyCreate',
      component: () => import('@/views/warranty/create'),
      meta: { title: '质保创建', icon: 'el-icon-plus', noCache: true }
    },
    {
      path: 'update',
      name: 'WarrantyUpdate',
      component: () => import('@/views/warranty/update'),
      meta: { title: '质保更新', icon: 'el-icon-plus', noCache: true },
      hidden: true
    },
    {
      path: 'table',
      name: 'WarrantyTable',
      component: () => import('@/views/warranty/table'),
      meta: { title: '质保查询', icon: 'el-icon-search', noCache: false }
    }
  ]
}
export default warrantyRouter
